import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducder from './slices/user.slice';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import topicReducer from './slices/topic.slice';
import prizeManagementReducer from './slices/prize_management.slice';
import missionReducer from './slices/mission.slice';
import wheelReducer from './slices/wheel.slice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'topic', 'prizeManagement', 'mission', 'wheel'],
};

const rootReducer = combineReducers({
  user: userReducder,
  topic: topicReducer,
  prizeManagement: prizeManagementReducer,
  mission: missionReducer,
  wheel: wheelReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
